// Theme: pop-pink
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'pop-pink',
  name: 'POP PINK',
  tagline: 'POP PINK',
  description: 'Pop pink Y2K. Rosa choque de palco com energia de videoclipe.',
  category: 'system-core',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#2C1023', '#3D1535', '#FF4FA8', '#FFE5F5'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '16px',
      '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
      '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)'
    },
    shellClasses: 'font-mono theme-pop-pink'
  },
  colorVars: {
    '--accent': '#FF4FA8',
    '--accent-foreground': '#2C1023',
    '--background': '#2C1023',
    '--border': '#4a1a37',
    '--card': '#3D1535',
    '--card-border-active': 'rgba(255, 79, 168, 0.10)',
    '--card-completed': '#36122F',
    '--card-foreground': '#FFE5F5',
    '--card-glow': 'rgba(255, 79, 168, 0.03)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2C1023',
    '--foreground': '#FFE5F5',
    '--hold-fill': '#FF4FA8',
    '--input': '#4a1a37',
    '--modal-bg': '#2C1023',
    '--modal-border': '#4a1a37',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#4a1a37',
    '--muted-foreground': '#FAD8E9',
    '--nav-active': '#FF4FA8',
    '--nav-bg': '#3D1535',
    '--popover': '#3D1535',
    '--popover-foreground': '#FFE5F5',
    '--primary': '#FF4FA8',
    '--primary-foreground': '#2C1023',
    '--ring': '#FF4FA8',
    '--secondary': '#4a1a37',
    '--secondary-foreground': '#FFE5F5',
    '--streak': '#FF4FA8',
    '--success': '#22c55e',
    '--success-foreground': '#2C1023',
    '--xp': '#FF4FA8',
    '--xp-bg': '#3D1535'
  },
  resolvedVars: {
    '--accent': '#FF4FA8',
    '--accent-foreground': '#2C1023',
    '--accent-foreground-hsl': '319 47% 12%',
    '--accent-foreground-oklch': 'from #2C1023 l c h',
    '--accent-hsl': '330 100% 65%',
    '--accent-oklch': 'from #FF4FA8 l c h',
    '--background': '#2C1023',
    '--background-hsl': '319 47% 12%',
    '--background-oklch': 'from #2C1023 l c h',
    '--border': '#4a1a37',
    '--border-hsl': '324 48% 20%',
    '--border-oklch': 'from #4a1a37 l c h',
    '--border-w': '1px',
    '--card': '#3D1535',
    '--card-border-active': 'rgba(255, 79, 168, 0.10)',
    '--card-completed': '#36122F',
    '--card-completed-hsl': '312 50% 14%',
    '--card-completed-oklch': 'from #36122F l c h',
    '--card-foreground': '#FFE5F5',
    '--card-foreground-hsl': '323 100% 95%',
    '--card-foreground-oklch': 'from #FFE5F5 l c h',
    '--card-glow': 'rgba(255, 79, 168, 0.03)',
    '--card-hsl': '312 49% 16%',
    '--card-oklch': 'from #3D1535 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2C1023',
    '--destructive-foreground-hsl': '319 47% 12%',
    '--destructive-foreground-oklch': 'from #2C1023 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FFE5F5',
    '--foreground-hsl': '323 100% 95%',
    '--foreground-oklch': 'from #FFE5F5 l c h',
    '--hold-fill': '#FF4FA8',
    '--hold-fill-hsl': '330 100% 65%',
    '--hold-fill-oklch': 'from #FF4FA8 l c h',
    '--input': '#4a1a37',
    '--input-hsl': '324 48% 20%',
    '--input-oklch': 'from #4a1a37 l c h',
    '--modal-bg': '#2C1023',
    '--modal-bg-hsl': '319 47% 12%',
    '--modal-bg-oklch': 'from #2C1023 l c h',
    '--modal-border': '#4a1a37',
    '--modal-border-hsl': '324 48% 20%',
    '--modal-border-oklch': 'from #4a1a37 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#4a1a37',
    '--muted-foreground': '#FAD8E9',
    '--muted-foreground-hsl': '330 77% 91%',
    '--muted-foreground-oklch': 'from #FAD8E9 l c h',
    '--muted-hsl': '324 48% 20%',
    '--muted-oklch': 'from #4a1a37 l c h',
    '--nav-active': '#FF4FA8',
    '--nav-active-hsl': '330 100% 65%',
    '--nav-active-oklch': 'from #FF4FA8 l c h',
    '--nav-bg': '#3D1535',
    '--nav-bg-hsl': '312 49% 16%',
    '--nav-bg-oklch': 'from #3D1535 l c h',
    '--popover': '#3D1535',
    '--popover-foreground': '#FFE5F5',
    '--popover-foreground-hsl': '323 100% 95%',
    '--popover-foreground-oklch': 'from #FFE5F5 l c h',
    '--popover-hsl': '312 49% 16%',
    '--popover-oklch': 'from #3D1535 l c h',
    '--primary': '#FF4FA8',
    '--primary-foreground': '#2C1023',
    '--primary-foreground-hsl': '319 47% 12%',
    '--primary-foreground-oklch': 'from #2C1023 l c h',
    '--primary-hsl': '330 100% 65%',
    '--primary-oklch': 'from #FF4FA8 l c h',
    '--radius': '16px',
    '--ring': '#FF4FA8',
    '--ring-hsl': '330 100% 65%',
    '--ring-oklch': 'from #FF4FA8 l c h',
    '--secondary': '#4a1a37',
    '--secondary-foreground': '#FFE5F5',
    '--secondary-foreground-hsl': '323 100% 95%',
    '--secondary-foreground-oklch': 'from #FFE5F5 l c h',
    '--secondary-hsl': '324 48% 20%',
    '--secondary-oklch': 'from #4a1a37 l c h',
    '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)',
    '--streak': '#FF4FA8',
    '--streak-hsl': '330 100% 65%',
    '--streak-oklch': 'from #FF4FA8 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#2C1023',
    '--success-foreground-hsl': '319 47% 12%',
    '--success-foreground-oklch': 'from #2C1023 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(330 100% 65% / 0.15)',
    '--xp': '#FF4FA8',
    '--xp-bg': '#3D1535',
    '--xp-bg-hsl': '312 49% 16%',
    '--xp-bg-oklch': 'from #3D1535 l c h',
    '--xp-hsl': '330 100% 65%',
    '--xp-oklch': 'from #FF4FA8 l c h'
  }
}
